'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M553.4 118.6L576 96 553.4 73.4 502.6 22.6 480 0 457.4 22.6 294.6 185.4 272 208l22.6 22.6L392 328l72-56 0-64 89.4-89.4zM432 208l0 48.3-37.3 29L317.3 208 480 45.3 530.7 96l-89.4 89.4-9.4 9.4 0 13.3zM249.4 230.6l-226 226L0 480s11.2 7.5 30 15.2c20.1 8.3 48.9 16.8 82 16.8c118.8 0 216.3-75.7 258.6-114.7l1.2-1.1c13.9-12.9 21.4-21.5 21.4-21.5l-9.4-9.4-22.6-22.6 .1-.1L338.7 320l-.1 .1L316 342.7l22.6 22.6 9.3 9.3c-12.9 11.8-31 27-53.3 42.3C247 449.4 183 480 112 480c-21.5 0-41.1-4.3-57.1-9.7L272 253.3l-22.6-22.6zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;